import { __rest } from "tslib";
import values from "lodash-es/values";
import EventEmitter from "../EventEmitter";
import EventTypes from "./EventTypes";
import * as observers from "./observers/observers";
/**
 * DocumentObserver
 */
var DocumentObserver = /** @class */ (function () {
    function DocumentObserver() {
        var _this = this;
        this.off = function (event, fn) {
            _this.observerListenCount[event]--;
            _this.emitter.off(event, fn);
            if (_this.observerListenCount[event] < 1) {
                _this.stopObserving(event);
            }
        };
        this.handleCallback = function (event) {
            var type = event.type, restProps = __rest(event, ["type"]);
            _this.emitter.emit(type, restProps);
        };
        this.observers = {};
        this.emitter = new EventEmitter();
        this.observerListenCount = {};
    }
    DocumentObserver.prototype.on = function (event, fn) {
        var _this = this;
        if (values(EventTypes).indexOf(event) === -1) {
            throw Error("Unknown event " + event);
        }
        this.emitter.on(event, fn);
        this.observerListenCount[event] = this.observerListenCount.hasOwnProperty(event) ? this.observerListenCount[event] + 1 : 1;
        if (!this.observers.hasOwnProperty(event)) {
            this.observe(event);
        }
        return function () { return _this.off(event, fn); };
    };
    DocumentObserver.prototype.observe = function (event) {
        var key = Object.keys(EventTypes).find(function (e) { return e.toLowerCase() === event.toLowerCase(); });
        var observer = new observers[key](this.handleCallback);
        this.observers[event] = observer;
        observer.start();
    };
    DocumentObserver.prototype.stopObserving = function (event) {
        if (this.observers.hasOwnProperty(event)) {
            var observer = this.observers[event];
            delete this.observers[event];
            observer.stop();
        }
    };
    return DocumentObserver;
}());
export default DocumentObserver;
//# sourceMappingURL=DocumentObserver.js.map